import {
    GET_BULK_ORDER_BY_ID,
    SET_BULK_ORDER_BY_ID
} from "./BulkOrderByIdType"

const getBulkOrderById = (payload: any) => ({
    type: GET_BULK_ORDER_BY_ID,
    payload
})

const setBulkOrderById = (bulkOrderbyIdValue: any) => ({
    type: SET_BULK_ORDER_BY_ID,
    bulkOrderbyIdValue: bulkOrderbyIdValue
})

export {
    getBulkOrderById,
    setBulkOrderById
}